/**
 * Constantes visuelles pour le PDF rapport — Ultra Mesure
 * Reproduit le format Word de Renaud (titres bleus, fond gris, couleurs corrosion).
 */
import { PDF_TEXT_COLORS, PDF_BG_COLORS } from "../palette";

// ─── Couleurs ────────────────────────────────────────────────

export const PDF_COLORS = {
  /** Bleu titres et en-tête */
  blue: "#0000CC",
  /** Fond gris clair pour sections et en-têtes tableau */
  grayBg: "#E8E8E8",
  /** Bordure grise */
  grayBorder: "#CCCCCC",
  /** Texte principal */
  text: "#333333",
  /** Texte secondaire */
  textMuted: "#666666",
  /** Texte clair (header/footer) */
  textLight: "#999999",
  /** Blanc */
  white: "#FFFFFF",
} as const;

/** Mapping codeCouleur → couleur texte (≈ format Word de Renaud).
 *  Source unique : modules/corrosion/palette.ts (champ pdfText). */
export const CORROSION_COLORS = PDF_TEXT_COLORS;

/** Mapping codeCouleur → couleur de fond légère pour les lignes tableau.
 *  Source unique : modules/corrosion/palette.ts (champ pdfBg). */
export const CORROSION_BG_COLORS = PDF_BG_COLORS;

// ─── Tailles de police ───────────────────────────────────────

export const PDF_FONT_SIZES = {
  /** Titre couverture */
  coverTitle: 20,
  /** Sous-titre couverture */
  coverSubtitle: 12,
  /** Titre de section (H1) */
  heading1: 14,
  /** Sous-titre (H2) */
  heading2: 12,
  /** Sous-sous-titre (H3) */
  heading3: 11,
  /** Corps de texte */
  body: 10,
  /** Petit texte (tableau, légende) */
  small: 8,
  /** Header/footer */
  headerFooter: 8,
} as const;

// ─── Marges ──────────────────────────────────────────────────

/** Marges du document [left, top, right, bottom] */
export const PDF_MARGINS: [number, number, number, number] = [40, 60, 40, 50];

// ─── Styles pdfmake ─────────────────────────────────────────

export const PDF_STYLES: Record<string, object> = {
  heading1: {
    fontSize: PDF_FONT_SIZES.heading1,
    bold: true,
    color: PDF_COLORS.blue,
    margin: [0, 12, 0, 6],
  },
  heading2: {
    fontSize: PDF_FONT_SIZES.heading2,
    bold: true,
    color: PDF_COLORS.blue,
    margin: [0, 8, 0, 4],
  },
  heading3: {
    fontSize: PDF_FONT_SIZES.heading3,
    bold: true,
    color: PDF_COLORS.text,
    margin: [0, 6, 0, 3],
  },
  body: {
    fontSize: PDF_FONT_SIZES.body,
    color: PDF_COLORS.text,
    lineHeight: 1.4,
  },
  small: {
    fontSize: PDF_FONT_SIZES.small,
    color: PDF_COLORS.textMuted,
  },
};

// ─── Labels corrosion ────────────────────────────────────────

export const CORROSION_LABELS: Record<string, string> = {
  green: "0-19% — Bon \u00e9tat",
  orange: "20-29% — Surveillance",
  red: "30-39% — Alerte",
  dark: "\u226540% — Critique",
};

/** Légende complète Renaud — utilisée sous le tableau de synthèse */
export const CORROSION_LEGEND_FULL: Array<{ code: string; text: string }> = [
  {
    code: "green",
    text: "En Vert, tuyauteries \u00e0 conserver — corrosion de 0 \u00e0 19 %.",
  },
  {
    code: "orange",
    text: "En Orange, tuyauteries \u00e0 surveiller tous les 2/3 ans, avec possibilit\u00e9 de sauvegarde — corrosion de 20 \u00e0 29 %.",
  },
  {
    code: "red",
    text: "En Rouge, tuyauteries \u00e0 remplacer car risques de percements ponctuels existants — corrosion de 30 \u00e0 39 %.",
  },
  {
    code: "dark",
    text: "En Rouge sombre, tuyauteries \u00e0 remplacer imp\u00e9rativement et rapidement — corrosion au-dessus de 40 %.",
  },
];
